import * as React from "react";
import Sidebar from "./Sidebar";
import Footer from "./Footer.web";
import Header from "./Header.web";

interface ILayoutProps {
  children?: React.ReactNode;
  secure?: boolean;
  sideBarVisible?: boolean;
  headerVisible?: boolean;
  footerVisible?: boolean;
}

export const DefaultLayout: React.FC<ILayoutProps> = ({
  sideBarVisible,
  footerVisible,
  secure,
  children,
  headerVisible
}) => {
  return (
    <div
      className={sideBarVisible ? "wrapper" : "d-flex flex-column full-height"}
    >
      {headerVisible && <Header />}
      {sideBarVisible && <Sidebar />}
      <section className="section-container d-flex flex-column">
        <div className="content d-flex flex-1">{children}</div>
        {footerVisible && <Footer />}
      </section>
    </div>
  );
};

DefaultLayout.defaultProps = {
  secure: false,
  sideBarVisible: true
};
